import BasicList from '../BasicList';
import {get} from '../../utils/fetch';
import { backendServer } from '../../variable';

const requestList = async ({page, pageSize, ...params}) => {
  try {
    const result = await get(`${backendServer}/agentBusinessRecord/query`, {
      page,
      pageSize,
      ...params
    });
    return result;
  } catch (e) {
    throw e;
  }
};

// 交易记录列表
const tradeRecordList = new BasicList(requestList);
tradeRecordList.setListName('交易记录');

export default tradeRecordList;



// WEBPACK FOOTER //
// ./src/stores/TradeRecordList/index.js